<template>
  <v-row :class="{ 'pb-4': $vuetify.breakpoint.xs }">
    <v-col class="py-0 d-flex justify-space-between">
      <span class="display-1 accent--text font-weight-light pt-3">
        <slot name="title" />
      </span>
      <slot name="right" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TopHeader"
}
</script>

<style lang="scss" scoped></style>
